import { Component, ViewEncapsulation } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FormBroadcast, FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { COUNTY_LIST_SEGMENT } from '@ptl/global-components';
import { ZipCountyModalComponent } from '../../../demographics/zip-county-modal/zip-county-modal.component';
import { ZipCountyStateStructure } from '../../../shared/interfaces/zipCountyStateStructure.interface';
import { CommonFormMemberLookupComponent } from '../common-form-member-lookup/common-form-member-lookup.component';

@FormComponentLookup('plan-change-member-lookup')
@Component({
    selector: 'app-plan-change-member-lookup',
    templateUrl: './plan-change-member-lookup.component.html',
    styleUrls: ['./plan-change-member-lookup.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PlanChangeMemberLookupComponent extends CommonFormMemberLookupComponent {
  
  currentRegion: string;

  constructor(private matDialog: MatDialog) {
    super();
  }

  ngOnInit(): void {
    this.commonInit();

    let zipState: ZipCountyStateStructure = this.reducerUtilityService.getComponentStates().ZipCounty;
    if (zipState?.county) {
      this.currentRegion = zipState.county.region;
    }
    else {
      // enforce branding if we don't have one currently
      this.changeRegion(true);
      return;
    }
  }

  changeRegion(disableClose: boolean, $event?: Event) {
    // for 'a' html tag clicks to stop link behavior
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }

    this.matDialog.open(ZipCountyModalComponent, {
      disableClose,  // controls mat dialog close like clicking out of modal
      data: {
        yearSelectionConfig: {
          hideYearSelection: this.entry.custom?.hideYearSelection
        },
        modalContent: {
          heading: this.entry.custom?.zipModalHeading,
          contentMain: this.entry.custom?.zipModalContent,
          buttonLabel: this.entry.custom?.zipModalButton
        }
      }
    });
  }
}